import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export interface LcPositionWithPool {
  positionId: string;
  poolId: string;
  lpShares: string;
  createdAt: string;
  updatedAt: string;
  pool?: {
    poolId: string;
    name: string;
    tokenASymbol: string;
    tokenBSymbol: string;
    reserveA: string;
    reserveB: string;
    totalLpShares: string;
    feeBps: number;
    status: string;
  };
}

interface UseMyPositionsReturn {
  positions: LcPositionWithPool[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useMyLiquidityCachePositions(): UseMyPositionsReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.liquidityCaches.positions(),
    queryFn: () => api.getMyLiquidityCachePositions(),
  });

  return {
    positions: data?.positions ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load positions' : null,
    refresh: () => {
      refetch();
    },
  };
}
